<template>
  <div class="container-withdraw-account" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.WithdrawalAccount.k038') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现名 -->
      <div class="select">
        <span>{{ $t('lang.WithdrawalAccount.k026') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <div class="select">
        <span>{{ $t('lang.WithdrawalAccount.k028') }}</span>
        <input style="color: #333" type="text" :placeholder="$t('lang.WithdrawalAccount.k032')" v-model.trim="accountName" />
      </div>

      <div class="select">
        <span>{{ $t('lang.BaseCommon.k103') }}</span>
        <div class="select-account">
          <div class="account-ph">+62</div>

          <input
            v-if="locaCode === 'ID'"
            type="text"
            maxlength="14"
            @input="only14digitNum($event, 'accountId')"
            :placeholder="$t('lang.WithdrawalAccount.k020')"
            v-model="accountId"
          />
          <input v-else type="text" :placeholder="$t('lang.BaseCommon.k103')" @input="onlyNum($event, 'accountId')" v-model="accountId" />
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'save-btn-act': this.saveFlag() }" @click="handleSave">
        {{ cfgId ? $t('lang.BaseCommon.k008') : $t('lang.WithdrawalAccount.k036') }}
      </div>
    </div>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          this.$client.showToast(this.$t('lang.WithdrawalAccount.k027'))
          return
        }

        // DANA
        if (this.withdrawalMethod === 'DANA') {
          if (this.locaCode === 'ID') {
            if (`${this.accountId}`.length < 10 || `${this.accountId}`.length > 14) {
              this.$client.showToast(this.$t('lang.WithdrawalAccount.k020'))
              return
            }
          }
        }

        const data = {
          accountId: this.accountId,
          accountName: this.accountName,
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 保存校验
    saveFlag() {
      if (this.accountId && this.accountName) {
        return true
      }

      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../base.scss';

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-withdraw-account .select .select-account .account-ph {
    border-right: 0px solid #d8d8d8 !important;
    border-left: 1px solid #d8d8d8 !important;
  }
}
</style>
